/**
 * SlotsCard Component
 * 시간대별 배달 슬롯 카드
 */
import React from 'react';
import styles from '../../styles/shared/SlotsCard.module.css';

const DEFAULT_SLOT_TIME_RANGES = [
    '평일: 06:00 ~ 12:59\n주말: 06:00 ~ 13:59',
    '평일: 13:00 ~ 16:59\n주말: 14:00 ~ 16:59',
    '평일: 17:00 ~ 19:59\n평일/주말 동일',
    '평일: 20:00 ~ 02:59\n평일/주말 동일',
];

const STATIC_SLOT_IDS = ['morning-lunch-peak', 'afternoon-non-peak', 'evening-peak', 'night-peak'];

interface SlotsCardProps {
    morningLunchPeakCount: number;
    afternoonNonPeakCount: number;
    eveningPeakCount: number;
    nightPeakCount: number;
    slotNames?: string[];
    slotCounts?: number[];
    slotTimeRanges?: string[];
    onSlotClick?: (slotId: string, slotName: string) => void;
    clickable?: boolean;
}

export const SlotsCard: React.FC<SlotsCardProps> = ({
                                                        morningLunchPeakCount,
                                                        afternoonNonPeakCount,
                                                        eveningPeakCount,
                                                        nightPeakCount,
                                                        slotNames,
                                                        slotCounts,
                                                        slotTimeRanges,
                                                        onSlotClick,
                                                        clickable = false,
                                                    }) => {
    const slotData = slotNames && slotNames.length > 0
        ? slotNames.map((name, idx) => ({
            id: STATIC_SLOT_IDS[idx] ?? `slot-${idx}`,
            name,
            count: slotCounts?.[idx] ?? 0,
            timeRange: slotTimeRanges?.[idx] ?? DEFAULT_SLOT_TIME_RANGES[idx] ?? '',
        }))
        : [
            { id: 'morning-lunch-peak', name: '아침/점심 피크', count: morningLunchPeakCount, timeRange: DEFAULT_SLOT_TIME_RANGES[0] },
            { id: 'afternoon-non-peak', name: '오후 논피크', count: afternoonNonPeakCount, timeRange: DEFAULT_SLOT_TIME_RANGES[1] },
            { id: 'evening-peak', name: '저녁 피크', count: eveningPeakCount, timeRange: DEFAULT_SLOT_TIME_RANGES[2] },
            { id: 'night-peak', name: '야간/심야', count: nightPeakCount, timeRange: DEFAULT_SLOT_TIME_RANGES[3] },
        ];

    const handleSlotClick = (slotId: string, slotName: string) => {
        if (clickable && onSlotClick) {
            onSlotClick(slotId, slotName);
        }
    };

    return (
        <div className={styles['slots-card']}>
            <h2 className={styles['slots-title']}>
                <span className={styles['slots-title-icon']}>📊</span>
                시간대별 배달 현황
            </h2>
            <div className={styles['slots-list']}>
                {slotData.map((slot) => (
                    <div
                        key={slot.id}
                        className={`${styles['slot-item']} ${clickable ? styles['slot-item-clickable'] : ''}`}
                        onClick={() => handleSlotClick(slot.id, slot.name)}
                    >
                        <div className={styles['slot-left']}>
                            <span className={styles['slot-name']}>{slot.name}</span>
                            <span className={styles['slot-range']}>
                                {slot.timeRange.split('\n').map((line, idx, arr) => (
                                    <React.Fragment key={idx}>
                                        {line}
                                        {idx < arr.length - 1 && <br />}
                                    </React.Fragment>
                                ))}
                            </span>
                        </div>
                        <div className={styles['slot-right']}>
                            <span className={styles['slot-count']}>{slot.count}<span className={styles['slot-unit']}>건</span></span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
